// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"61f9995a","38":"7d192970","76":"88516867","84":"96800aec","124":"8ba7e318","161":"b85438f0","558":"d5364eed","697":"25063d4e","844":"13d4cd15","933":"f552a00e"}[chunkId] + ".chunk.js";
};